import React from 'react';
import { ButtonBorderedS } from './styles';

interface ButtonDoneProps {
  onClick: () => void;
  title?: string;
}

export const ButtonDone: React.FC<ButtonDoneProps> = ({ onClick, title = 'Done' }) => {
  return (
    <ButtonBorderedS onClick={onClick}>
      {title}
    </ButtonBorderedS>
  );
};
